import { Box, Grid } from "@mui/material";
import { ReactElement } from "react";
import { useAppSelector } from "../../app/hooks";
import OverlaySpinner from "../../common/components/functional/overlaySpinner/OverlaySpinner";

type Props = {
  top: ReactElement;
  left: ReactElement;
  right: ReactElement[];
};

const DashboardGridLayout = ({ top, left, right }: Props) => {
  // TODO: add one main status of dashboard slice
  const { status: hrTasklistStatus } = useAppSelector(
    (state) => state.dashboard.hrTasklist,
  );
  const { status: talentsStatus } = useAppSelector(
    (state) => state.dashboard.talents,
  );

  const isLoading =
    hrTasklistStatus === "pending" || talentsStatus === "pending";

  return (
    <>
      <OverlaySpinner isLoading={isLoading} />
      {top}
      <Box maxWidth="1800px">
        <Grid container spacing={2}>
          {left}
          <Grid item container xs={8.9}>
            <Grid item xs>
              {right}
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default DashboardGridLayout;
